
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infographic-templates/category/neutral/format/[slug]",
      function () {
        return require("private-next-pages/infographic-templates/category/neutral/format/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infographic-templates/category/neutral/format/[slug]"])
      });
    }
  